import React, { useState } from 'react';
import {

Dialog,
DialogTitle,
DialogContent,
DialogActions,
Button,
Radio,
RadioGroup,
FormControlLabel,
TextField,
} from '@mui/material';
import { toast } from 'react-toastify';
import { TimePickerComponent, DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { useUpdateOrderStatusMutation } from '../../../features/Dispatch/TripDispatchSlice';

const PickupModal = (props) => {
const [selectedOption, setSelectedOption] = useState('current');
const [selectedDate, setSelectedDate] = useState('');
const [selectedTime, setSelectedTime] = useState('');
const [updateOrderStatus] = useUpdateOrderStatusMutation();

const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
};

const statusCodeMap = {
    'P': 'Pickup',
    'PX': 'Pickup Cross Dock',
    'DX': 'Delivery Cross Dock',
    'OD': 'Out for Delivery',
    'D': 'Delivery',
}

const statusMap = {
    'O': 'Open',
    'L': 'Loading',
    'OUT': 'Outbound',
    'IN': 'Inbound',
    'C': 'Completed',
}

const handleSubmit = async () => {
    const date = selectedDate ? new Date(selectedDate).toISOString().split('T')[0] : null;
    const time = selectedTime ? new Date(selectedTime).toLocaleTimeString('en-GB').slice(0, 5) : null

    const now = new Date();
    const nowDate = now.toISOString().split('T')[0];
    const nowTime = now.toLocaleTimeString('en-GB').slice(0, 5);

    const body = {
        orderId: props.orderID,
        orderNumber: props.orderNumber,
        divisionId: props.divisionId,
        outTime: selectedOption === 'custom' ? date + 'T' + time: nowDate + 'T' + nowTime,
        isChecked: true,
        orderStatusCode: props.orderStatusCode
    };
    const result = await updateOrderStatus(body)
    if (result.data?.statusCode === 200) {
        toast.success(result.data.data.message , { position: 'top-center' });
        props.setShowPickupModal(false);
        props.getAllOpenTripOrders(props.divisionId);
        if (props.selectedTrip) {
            props.refetchTripOrders();
            props.getTripOrdersClassification({ tripStatus: statusMap[props.selectedTrip?.tripStatusCode], tripId: props.selectedTrip?.tripID, divisionId: props.divisionId });
        }
    } else {
        toast.error(result?.error.data?.data?.message, { position: 'top-center' });
    }
};

const onClose = () => {
    setSelectedOption('current');
    setSelectedDate('');
    setSelectedTime('');
    props.setShowPickupModal(false);
}

return (
    <Dialog open={props.showPickupModal} onClose={onClose}>
        <DialogTitle>{statusCodeMap[props.orderStatusCode]} Date/Time</DialogTitle>
        <DialogContent>
            <RadioGroup value={selectedOption} onChange={handleOptionChange}>
                <FormControlLabel
                    value="current"
                    control={<Radio />}
                    label="Current Date/Time"
                    className='mb-2'
                />
                <FormControlLabel
                    value="custom"
                    control={<Radio />}
                    label="Select Date/Time"
                />
                <div className="timepicker d-flex gap-2 mt-2">
                    <DatePickerComponent
                        className='mb-2'
                        id="datepicker"
                        placeholder="Select Date"
                        format="yyyy-MM-dd"
                        name="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                    />
                    <TimePickerComponent
                        id="time"
                        placeholder="Select Time"
                        format="hh:mm a"
                        name="time"
                        value={selectedTime}
                        onChange={(e) => setSelectedTime(e.target.value)}
                    />
                </div>
            </RadioGroup>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={handleSubmit} color="primary">
                Submit
            </Button>
        </DialogActions>
    </Dialog>
);
};

export default PickupModal;